import styled from '@emotion/styled'

export const StyledAppContainer = styled('div')(({ theme }) => ({
  textAlign: 'center',
  backgroundColor: theme.primary[900],
  padding: 0,
}))
